import { Component } from '@angular/core';
import { ITab } from '../controls/tab/tab.component';
import { IOption } from '../controls/models/option';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NomOrgService } from './shared/services/nom-org.service';
import { ICommitteeRole, INominatingOrganisation } from './shared/models/nom-org';
import { IUpdateNominatingOrganisationRequest } from './shared/models/nom-org-update';
import { ToastService } from '../../shared/services/toast.service';
import { IApiResponse } from '../../shared/models/api-response';

@Component({
    selector: 'app-nom-org',
    templateUrl: './nom-org.component.html',
    styleUrl: './nom-org.component.scss',
    standalone: false
})
export class NomOrgComponent {
  loading: boolean = false;
  isUpdatingNomOrg: boolean = false;

  selectedTab: string = '';
  subscriptions: Subscription = new Subscription();
  committees: string[] = [];
  tabIds = {
    committeesRepresentedOn: 'committeesRepresentedOn',
    projects: 'projects',
    myRepresentatives: 'myRepresentatives',
    subCommitteesAndWorkingGroups: 'subCommitteesAndWorkingGroups',
    declarationOfInterest: 'declarationOfInterest',
  };

  tabs: ITab[] = [
    { id: this.tabIds.committeesRepresentedOn, label: 'Committees Represented On' },
    { id: this.tabIds.projects, label: 'Projects' },
    { id: this.tabIds.myRepresentatives, label: 'My Representatives' },
    //{ id: this.tabIds.declarationOfInterest, label: 'Declaration of Interest' }
  ];

  nomOrgForm = new FormGroup({
      email: new FormControl(''),
      phone: new FormControl(''),
      website: new FormControl('')
  });

  initialFormValue = this.nomOrgForm.getRawValue();

  nominatingOrganizationList : IOption<string>[] = [];
  nominatingOrganizations: INominatingOrganisation[] = [];
  selectedNominatingOrganization!: INominatingOrganisation | null;

  committeeTableData: ICommitteeRole[] = [];

  isNomOrgDetailsChanged: boolean = false;

  constructor(private _nomOrgService: NomOrgService,
              private _toastService: ToastService
  ) {}

  get email(){
    return this.nomOrgForm.get('email');
  }
  get phone() {
    return this.nomOrgForm.get('phone');
  }
  get website() {
    return this.nomOrgForm.get('website');
  }

  ngOnInit(): void {
    this.getNomOrgs();
  }

  ngAfterViewInit() {
    this.nomOrgForm.valueChanges.subscribe(currentValue => {
      this.isNomOrgDetailsChanged =
        JSON.stringify(currentValue) !== JSON.stringify(this.initialFormValue);
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  onNomOrgSelect(value: any) {
    if (this.nominatingOrganizations) {
      this.selectedNominatingOrganization = this.nominatingOrganizations.find(nomOrg => nomOrg.id == value)??null;
      this.committeeTableData = this.selectedNominatingOrganization?.commiteeRoles??[];
      this.committees = this.selectedNominatingOrganization?.commiteeCodes ?? [];
      this.loadNomOrgDetails();
    }
  }

  onTabChange(tabId: string) {
    this.selectedTab = tabId;
  }

  getNomOrgs() {
    this.loading = true;
    const getNomOrgDetailsSubscription = this._nomOrgService
          .getNomOrgs()
          .subscribe({
            next: (response: IApiResponse<INominatingOrganisation[]>) => {
              if (response.success) {
                this.nominatingOrganizations = response.content;
                this.nominatingOrganizationList = this.nominatingOrganizations.map(x => ({ value: x.id, label: x.name }));
                this.onNomOrgSelect(this.nominatingOrganizations[0].id);
              }
              this.loading = false;
            },
            error: _ => {
              this.loading = false;
            },
          });

    this.subscriptions.add(getNomOrgDetailsSubscription);
  }

  loadNomOrgDetails() {
    const nomOrgDetails = {
      email: this.selectedNominatingOrganization?.email??"",
      phone: this.selectedNominatingOrganization?.phone??"",
      website: this.selectedNominatingOrganization?.website??""
    }
    this.nomOrgForm.patchValue(nomOrgDetails);

    this.initialFormValue = this.nomOrgForm.getRawValue();
    this.isNomOrgDetailsChanged = false;
  }

  updateNomOrgDetails() {
    this.isUpdatingNomOrg = true;
    let nomOrgUpdateRequest = this.getUpdateNomOrgRequest();
    const nomOrgUpdate = this._nomOrgService.updateNomOrg(nomOrgUpdateRequest).subscribe({
          next: (response: IApiResponse<number>) => {
            this._toastService.showSuccess("Nominating Organization is updated successfully");
            this.isUpdatingNomOrg = false;
            this.getNomOrgs();
          },
          error: (error) => {
            this._toastService.showError("Failed updating nominating Organization");
            this.isUpdatingNomOrg = false;
          }
        });

    this.subscriptions.add(nomOrgUpdate);
  }

  getUpdateNomOrgRequest() : IUpdateNominatingOrganisationRequest {
    return {
      nominatingOrganisationId : this.selectedNominatingOrganization?.id??"",
      salesforceContactId : this.email?.value??"",
      phone : this.phone?.value??"",
      website : this.website?.value??""
    }
  }

}
